import Repository from './Repository'

export default Repository
